import useTabsOrganizationProfile from 'Hooks/useTabsOrganizationProfile';
import useTranslate from 'Hooks/useTranslate';
import { generatePath, useParams } from 'react-router-dom';
import { PrivateRoutes } from 'Router/Routes';
import ProfilePageTemplate from 'Components/Shared/ProfileTemplate/ProfilePageTemplate';

interface Props {
  organization: IOrganization;
}

function OrganizationProfile({ organization }: Readonly<Props>) {
  const ts = useTranslate();
  const tabs = useTabsOrganizationProfile({ organization });

  const { accountCode, organizationCode } = useParams<{
    accountCode: string;
    organizationCode: string;
  }>();

  const basePath = generatePath(PrivateRoutes.organizationProfile.path, {
    accountCode: accountCode,
    organizationCode: organizationCode
  });

  return (
    <ProfilePageTemplate
      title={ts('page.organizations.title', {
        value: organization.name
      })}
      basePath={basePath}
      tabs={tabs}
    />
  );
}

export default OrganizationProfile;
